// Plain-language hints for the two failures that actually happen in this app.
// Both are silent by nature: the listener simply never delivers a snapshot, so
// the UI shows an empty list that is indistinguishable from "no data".
const HINTS = {
    'failed-precondition':
        'Deze query heeft een samengestelde index nodig die nog niet bestaat. ' +
        'De link in de melding hieronder maakt hem aan.',
    'permission-denied':
        'De Firestore-regels blokkeren deze lees-actie.',
};

const formatConstraints = (constraints) => {
    const list = Array.isArray(constraints) ? constraints : [];

    if (list.length === 0) return '(geen filters)';

    return list
        .map(([field, op, value]) => `${field} ${op} ${JSON.stringify(value) ?? String(value)}`)
        .join(' && ');
};

/**
 * Build the console message for a failed Firestore listener.
 *
 * @param {string} collection
 * @param {Array<[string, string, any]>} [constraints]
 * @param {{code?: string, message?: string}} [error]
 * @returns {string}
 */
const describeQueryError = (collection, constraints, error) => {
    const code = error?.code ? ` [${error.code}]` : '';
    const hint = HINTS[error?.code] ? ` ${HINTS[error.code]}` : '';
    const message = error?.message || String(error ?? 'onbekende fout');

    return `Firestore-query op "${collection}" faalde${code}.${hint} ` +
        `Filters: ${formatConstraints(constraints)}. ${message}`;
};

export default describeQueryError;
